var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 10.62h-.5V5a1 1 0 0 0-.38-.8l-3.5-2.71a1 1 0 0 0-1.24 0L1.88 4.2a1 1 0 0 0-.38.78l-.02 5.64H1a.37.37 0 1 0 0 .75h10c.2 0 .38-.17.38-.37a.37.37 0 0 0-.38-.38ZM5.25 3.37h1.5c.2 0 .38.17.38.38 0 .2-.17.37-.38.37h-1.5a.38.38 0 0 1-.38-.37c0-.2.17-.38.38-.38Zm3.25 7.25h-5c0-.5 2.08-5.12 2.5-5.12.42 0 2.5 4.62 2.5 5.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamp);
export default ForwardRef;